<template>
  <div
    id="kb-related-articles"
    style="border-top: 1px solid #e6e6e6;"
  >
    <h3>関連記事</h3>
    <h6>
      <ul>
        <li
          v-for="article in relatedActicalList"
          :key="article.id"
        >
          <router-link :to="`/faq/${article.id}`">
            {{ article.title }}
          </router-link>
        </li>
      </ul>
    </h6>
  </div>
</template>

<script>
export default {
  name: 'RealtedArticle',
  components: {},
  props: {
    relatedActicalList: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
#kb-related-articles h3 {
  margin-top: 50px;
  margin-bottom: 12px;
}
#kb-related-articles h6 {
  margin-top: 12px;
}
#kb-related-articles ul {
  padding-left: 0;
  margin-top: 0;
  list-style-type: none;
}
#kb-related-articles ul li {
  margin-top: 1rem;
  font-size: 14px;
}
#kb-related-articles ul li:first-child {
  margin-top: 0;
}
</style>
